import { render, staticRenderFns } from "./campaignName.vue?vue&type=template&id=0e537050&scoped=true&"
import script from "./campaignName.vue?vue&type=script&lang=js&"
export * from "./campaignName.vue?vue&type=script&lang=js&"
import style0 from "./campaignName.vue?vue&type=style&index=0&id=0e537050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e537050",
  null
  
)

export default component.exports